"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SchDocAsciiConverter = void 0;
const StreamParser_1 = require("./binary/StreamParser");
const SchDocParser_1 = require("./SchDocParser");
const AsciiStreamParser_1 = require("./ascii/AsciiStreamParser");
const ASCII_SCHEMATIC_HEADER = 'Protel for Windows - Schematic Capture Ascii File Version 5.0';
const BINARY_SCHEMATIC_HEADER = 'Protel for Windows - Schematic Capture Binary File Version 5.0';
class SchDocAsciiConverter {
    static async convert(blob) {
        const isCfb = await SchDocParser_1.SchDocParser.IsCfb(blob);
        if (!isCfb) {
            return blob.text();
        }
        const streamParser = await StreamParser_1.StreamParser.fromBlob(blob);
        const fileHeaderRecords = await streamParser.parseFileHeader();
        const additionalRecords = (await streamParser.parseAdditional()) ?? [];
        const serializedFileHeader = fileHeaderRecords.map((props) => SchDocAsciiConverter.serializeRecord(props));
        if (additionalRecords.length === 0) {
            return serializedFileHeader.join('\r\n');
        }
        return [
            ...serializedFileHeader,
            AsciiStreamParser_1.ASCII_ICON_STORAGE_HEADER,
            ...additionalRecords.map((props) => SchDocAsciiConverter.serializeRecord(props)),
        ].join('\r\n');
    }
    static serializeRecord(properties) {
        const parts = Object.values(properties)
            .filter((prop) => prop !== undefined)
            .map((prop) => {
            const baseKey = prop.key.replace(/^%UTF8%/i, '');
            const value = baseKey.toLowerCase() === 'header' && prop.value === BINARY_SCHEMATIC_HEADER ?
                ASCII_SCHEMATIC_HEADER
                : prop.value;
            const key = SchDocAsciiConverter.hasNonAscii(value) ? `%UTF8%${baseKey}` : baseKey;
            return `${key}=${value}`;
        });
        return '|' + parts.join('|');
    }
    static hasNonAscii(value) {
        for (let i = 0; i < value.length; i++) {
            if (value.charCodeAt(i) > 0x7f) {
                return true;
            }
        }
        return false;
    }
}
exports.SchDocAsciiConverter = SchDocAsciiConverter;
//# sourceMappingURL=SchDocAsciiConverter.js.map